import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { BOOKING_URL } from '../../data/services';

const VIDEO_URL = "https://customer-assets.emergentagent.com/job_beauty-longevity/artifacts/a0krxbit_copy_4D723626-DA2B-47E7-91DE-9442DFB1E2C8.MOV";
const FALLBACK_IMAGE = "https://images.pexels.com/photos/3997983/pexels-photo-3997983.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const HeroSection = () => {
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section 
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={FALLBACK_IMAGE}
          className="w-full h-full object-cover"
          data-testid="hero-video"
        >
          <source src={VIDEO_URL} type="video/quicktime" />
          <source src={VIDEO_URL} type="video/mp4" />
        </video>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 video-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-4xl"
        >
          {/* Brand Name */}
          <motion.p
            initial={{ opacity: 0, letterSpacing: '0.5em' }}
            animate={{ opacity: 1, letterSpacing: '0.3em' }}
            transition={{ duration: 1.2, delay: 0.5 }}
            className="font-cinzel text-white/90 text-sm md:text-base mb-4 tracking-[0.3em]"
          >
            APHRODITE MED SPA
          </motion.p>

          {/* Main Headline */}
          <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-7xl leading-tight mb-6">
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              className="block"
            >
              Awaken Your
            </motion.span>
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.9 }}
              className="block italic text-thulian"
            >
              Goddess Energy
            </motion.span>
          </h1>

          {/* Subheadline */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.1 }}
            className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 tracking-wide"
          >
            Elevated Aesthetic & Longevity Medicine in Los Angeles
          </motion.p>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.3 }}
          >
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-btn"
              className="btn-luxury inline-block bg-amaranth text-white px-10 py-4 rounded-full text-sm font-medium tracking-widest uppercase"
            >
              View Treatments
            </a>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.8 }}
          onClick={scrollToContent}
          data-testid="scroll-indicator"
          className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors"
          aria-label="Scroll to content"
        >
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <ChevronDown size={32} />
          </motion.div>
        </motion.button>
      </div>
    </section>
  );
};

export default HeroSection;
